export default "__VITE_ASSET__BsnBgmBL__"